import { Icon, Intent, Popover, PopoverInteractionKind, Position, Tag } from "@blueprintjs/core"
import { __, getID } from "src/libs/utilities"
import CardFieldTypeField from "./CardFieldTypeField"
import { CARD_FIELD_TYPE, CardsContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import cardFieldsDefault from "src/modules/pe-landing-module/data/utils/cardFieldsDefault" 

/* Protopia Ecosystem component */ 
export interface ICardsFieldsFilterPanelProps {
   
}
const CardsFieldsFilterPanel = (props: ICardsFieldsFilterPanelProps): JSX.Element => {
    const currentCardEdit: CardsContent	= useLandingStore( (state: ILandingStore) => state.currentCardEdit ) 

    const onChoose = (key: CARD_FIELD_TYPE ) => { 
        currentCardEdit.card_fields.push({
            ...cardFieldsDefault()[ key ].card_field,
            id: getID( key.toString() )
        })
        currentCardEdit.cards.forEach(card => {
            card.value.push( cardFieldsDefault()[ key ].value )
        })
        currentCardEdit.order.push(key)
        console.log(currentCardEdit)
        
        useLandingStore.setState({ currentCardEdit })
    }
    return <div className='landing-select-layer-panel align-items-center'>
        <Tag 
            //minimal
            intent={ Intent.DANGER }
            size="medium" 
            className="small text-light py-0 px-1 mb-1 mx-1 hover pointer"
        >
            <Popover
                position={ Position.BOTTOM_LEFT}
                interactionKind={PopoverInteractionKind.CLICK}
                content={<CardFieldTypeField onChoose={onChoose} />}
                portalClassName="z-index-120" 
            >    
                <div className="small letter-spacing-1 opacity_75 d-flex align-items-center ">  
                    <Icon icon="plus" size={ 9 } /> 
                    <div className="small pl-1">
                        {__("Add card field")}
                    </div> 
                </div>
            </Popover>
        </Tag>
    </div>
}
export default CardsFieldsFilterPanel